module.exports = __webpack_public_path__ + "img/handball-dark.7fef1584.svg";